function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Iellipse = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: "8",
    height: "8",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Validaci\xC3\xB3n mobile"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-535 -505C-535 -506.105 -534.105 -507 -533 -507H2090C2091.1 -507 2092 -506.105 2092 -505V709C2092 710.105 2091.1 711 2090 711H-533C-534.105 711 -535 710.105 -535 709V-505Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-533 -506H2090V-508H-533V-506ZM2091 -505V709H2093V-505H2091ZM2090 710H-533V712H2090V710ZM-534 709V-505H-536V709H-534ZM-533 710C-533.552 710 -534 709.552 -534 709H-536C-536 710.657 -534.657 712 -533 712V710ZM2091 709C2091 709.552 2090.55 710 2090 710V712C2091.66 712 2093 710.657 2093 709H2091ZM2090 -506C2090.55 -506 2091 -505.552 2091 -505H2093C2093 -506.657 2091.66 -508 2090 -508V-506ZM-533 -508C-534.657 -508 -536 -506.657 -536 -505H-534C-534 -505.552 -533.552 -506 -533 -506V-508Z",
    fill: "black",
    "fill-opacity": "0.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "-",
    "clip-path": "url(#clip0_1_26)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "360",
    height: "996",
    transform: "translate(-32 -427)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Form"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Selected"
  }, /*#__PURE__*/React.createElement("g", {
    id: "punto"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 227",
    cx: "4",
    cy: "4",
    r: "4",
    fill: "#ADB5BD"
  })))))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "360",
    height: "996",
    fill: "white",
    transform: "translate(-32 -427)"
  }))));
});